module.exports = __webpack_public_path__ + "static/quote-91fb74ddb410ada1d179b22fe53b7847.png";